/**
 * T13.6 — deterministic radial layout for the Brain graph.
 * Root at center, sub-agents on an inner ring, tools on an outer ring
 * clustered by the agents that use them. Pure function so it stays testable.
 */
export function layoutBrainGraph(nodes, edges, { radius = 320, toolRadius = 560 } = {}) {
  const agents = nodes.filter((node) => node.type === 'orchestrator' || node.type === 'subAgent');
  const tools = nodes.filter((node) => node.type === 'tool');

  const ring = agents
    .filter((node) => node.type === 'subAgent')
    .map((node) => node.id);

  const angleStep = (Math.PI * 2) / ring.length;

  const positions = {
    'agent-0': { x: 0, y: 0 }
  };

  ring.forEach((id, index) => {
    const angle = angleStep * index - Math.PI / 2;
    positions[id] = {
      x: Math.cos(angle) * radius,
      y: Math.sin(angle) * radius
    };
  });

  // Cluster tools near the midpoint of their parent agents.
  tools.forEach((node) => {
    const parents = edges
      .filter((edge) => edge.target === node.id)
      .map((edge) => positions[edge.source])
      .filter(Boolean);

    if (parents.length === 0) {
      positions[node.id] = { x: 0, y: toolRadius };
      return;
    }

    const midX = parents.reduce((sum, p) => sum + p.x, 0) / parents.length;
    const midY = parents.reduce((sum, p) => sum + p.y, 0) / parents.length;
    const length = Math.hypot(midX, midY) || 1;

    positions[node.id] = {
      x: (midX / length) * toolRadius,
      y: (midY / length) * toolRadius
    };
  });

  return nodes.map((node) => ({ ...node, position: positions[node.id] ?? { x: 0, y: 0 } }));
}
